import styled from "styled-components";

export const StyledManageOrganizationChart = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & .content-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .footer-container {
    width: 100%;
  }
`;
